<template>
  <action-person-template :action="action" column="person" grid="person" title="Tireur"/>
</template>

<script>
import ActionPersonTemplate from './ActionPersonTemplate'

export default {
  name: 'SportFootballMatchActionPersonShooter',
  props: {
    action: Object
  },
  components: { ActionPersonTemplate }
}
</script>
